"use strict";
/**
 * @module Services.TopicViews
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The result type of of TopicViews LIST_TOPIC_VIEWS service
 */
var ListTopicViewsResult = /** @class */ (function () {
    /**
     * Create a new ListTopicViewsResult instance
     *
     * @param result  the array of topic views
     */
    function ListTopicViewsResult(result) {
        this.result = result;
    }
    return ListTopicViewsResult;
}());
exports.ListTopicViewsResult = ListTopicViewsResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-views/list-topic-views-result.js
// module id = 1392
// module chunks = 1